/** Cardinality of every slot; the registry assembler enforces capacity. */
export const SLOT_CARDINALITY = {
    banner: 'many',
    eyebrow: 'one',
    chin: 'many',
    inputHeader: 'many',
    attachmentTray: 'one',
    leftAttribution: 'many',
    rightAttribution: 'many',
};
//# sourceMappingURL=slots.js.map